export default __webpack_public_path__ + "e4d61a7d54daa6339543fb7441dc5780.png";